import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {Account} from "../types.ts";
import {useAccount} from "../hooks/useAccount.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        record,
        createRecord,
    } = useAccount();

    return (
        <FormDrawer
            record={record ?? {} as Account}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
